module.exports = __webpack_public_path__ + "img/treebu_icon.919217f6.png";